<!--
    1. 这个组件目前暂时不做分页了
    2. 移动端是每行显示 4 个，手机端是每行显示 3 个
-->

<template>
    <div>
        <my-dialog ref="dialog" title="我的关注列表">
            <div v-if="hasFollows && !noSignalVisible" class="list-wrap">
                <div v-if="followChunks==null"><loading :text="null"></loading></div>
                <template v-else v-for="chunk in followChunks">
                    <el-row>
                    <template v-for="f in chunk">
                        <el-col :span="colSpan">
                            <div class="profile">
<!--                                <el-image lazy-->
<!--                                          :src="f.avatar"-->
<!--                                          fit="cover"-->
<!--                                          class="avatar"-->
<!--                                          style="cursor: pointer; border:0.5px solid #DCDFE6;width:100%;height:100%"-->
<!--                                          @click.native="navigate(f.code)"-->
<!--                                />-->
                                <sy-loading-image :src="f.avatar" v-if="showAvatar"
                                                  class-str="avatar"
                                                  :style-str="`object-fit: cover; cursor: pointer; border:0.5px solid #DCDFE6;width:100%;height:100%`"
                                                  @click.native="navigate(f.code)">
                                    <img slot="loading"
                                         class="avatar"
                                         style="object-fit: cover;cursor: pointer; border:0.5px solid #DCDFE6;width:100%;height:100%"
                                         :src="require('@/assets/transparent-gray_320x320.png')"/>
                                </sy-loading-image>
                                <avatar v-else :hash="f.name" :isDefaultRotate="false" :size="60"></avatar>
                                <div>
                                    <profile-name :name="f.name"
                                                  :code="f.code"
                                                  @navigated="navigated"
                                                  :style-object="{lineHeight: '30px',
                                                                  fontWeight: '600',
                                                                  fontSize: '14px',
                                                                  // 以下三个关键属性是当名字超出后隐藏效果
                                                                  overflow: 'hidden',
                                                                  whiteSpace: 'nowrap',
                                                                  textOverflow: 'ellipsis'}" />
                                </div>
                            </div>
                        </el-col>
                    </template>
                    </el-row>
                </template>
            </div>
            <div v-else-if="!noSignalVisible" class="margin-top-20px">暂无记录</div>
            <no-signal
                v-if='noSignalVisible'
                ref="noSignal"
                display-mode="vertical"
                :retry-handlers="[fetchFollows]"
                :retry-basis="false"
                :margin-top="0"></no-signal>
        </my-dialog>
    </div>
</template>

<script>
    import MyDialog from "../../commons/MyDialog";
    import ProfileName from "../../profile/Name";
    import SyLoadingImage from "../../commons/SyLoadingImage";
    import { getProfiles } from "../../../data/profile";
    import util from "util";
    import assert from 'assert';
    import { ShowEntityMode, isPhoneAgent, errorMessage } from "../../../utils";
    import { TimeoutError, NetworkError } from '@shangyang/error';

    export default {
        name: "MyFollows",
        components: {MyDialog, ProfileName, SyLoadingImage},
        data(){
            return{
                followChunks: null,
                hasFollows: false,
                colSpan: 6, // 默认是 PC 端，每行显示 4 个，因此 24/4 = 6，而手机端显示 3 个，因此该值等于 8
                noSignalVisible: false
            }
        },
        computed: {
            showAvatar(){
                if (this.$store.state.displayCtrl !== null){
                    return this.$store.state.displayCtrl.avatar;
                }else{
                    return false;
                }
            }
        },
        methods: {
            show: function(){
                // 延时显示
                setTimeout(()=>{
                    this.hasFollows = this.$store.getters.getUser().follows.length > 0 ? true : false
                    this.$refs.dialog.show();
                    // Fix a bug, 必须在 dialog show 之后设置 display mode。否则 Dialog 不能正确的缓存当前 $route 的 display mode
                    this.$store.commit('setIsProfileNameNavigble', true);  // 从 profile route to channel， IsProfileNameNavigble == false，因此这里还是需要设置。
                    // TODO, refine the mode name to be more reasonable
                    this.$store.commit('setShowEntityMode', ShowEntityMode.SinglePageMode); //if SinglePageMode，will use route
                }, 300);
                this.fetchFollows(); // 每次显示的时候重新加载。
            },
            /**
             * 思路和 UserFavorLikes 一致，首先从缓存中取，取不到的批量远程获取，最后倒叙展示（最近关注的放到前面展示）
             */
            fetchFollows: function(){
                (async() => {
                    try {
                        console.log('fetch follows', this.$store.getters.getUser().follows);
                        // 后面会使用到 lodash reverse follow codes order，lodash 会改变原有 follows codes 的顺序，为了避免原有顺序被打乱，这里 clone
                        let codes = _.clone(this.$store.getters.getUser().follows);
                        // 1. 先检查缓存，若没有缓存，则远程获取
                        let notCached = [];
                        for(let code of codes){
                            let p = this.$store.getters.getProfile(code);
                            // if not fetched from cache, then retrieve it remotely
                            if(util.isNullOrUndefined(p))
                                notCached.push(code);
                        }
                        let profiles = await getProfiles.bind(this)(notCached); // will cache those profiles in client after fetch
                        // 2. 最近关注的展示到最前面
                        let follows = [];
                        for(let code of codes){
                            let p = this.$store.getters.getProfile(code);
                            assert.ok(!util.isNullOrUndefined(p), `the profile code ${code} should be catched this time`);
                            follows.push(p);
                            // 下面是在本地开发环境下的 mock 数据，因为 profile 太少，因此这样来添加调整样式所用。
                            // follows.push(p);
                            // follows.push(p);
                            // follows.push(p);
                            // follows.push(p);
                            // follows.push(p);
                            // follows.push(p);
                            // follows.push(p);
                            // follows.push(p);
                        }
                        if(isPhoneAgent()){
                            this.colSpan = 8;
                            this.chunkSize = 3;
                        }else{
                            this.colSpan = 6;
                            this.chunkSize = 4;
                        }
                        this.followChunks = _.chunk(follows, this.chunkSize); // 4 个一排
                        console.log('follow chunks', this.followChunks);
                        this.noSignalVisible = false;
                    } catch(error) {
                        console.error(error);
                        if (error instanceof TimeoutError || error instanceof NetworkError) {
                            errorMessage(error.message);
                            this.noSignalVisible = true; // 显示 no signal comp
                        }
                    }
                })();
            },
            navigate(channelCode){
                this.$router.push({path: `/p/${channelCode}`});
                this.navigated();
            },
            // 当点击了 profile name 进行 route 之后，要关闭 dialog。
            navigated(){
                this.$refs.dialog.hide();
            }
        }
    }
</script>

<style scoped>
    .profile{
        padding: 20px 20px 20px 20px
    }

    @media (max-width:735px){
        .profile{
            padding: 10px 10px 10px 10px
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/user/center/UserFollows.vue